module.exports = __webpack_public_path__ + "static/media/schedule_structure_add_a_lunch.be92a12b.mov";